import React, { useState } from "react";
import Button from "Components/common/Button";
import DropdownMenu from "Components/common/DropDownMenu";
import { accountsState } from "../AccountsState";
import { addAccountPopupState } from "./AddAccountPopup";

// Lives in the page header (Main.js), next to the "Accounts" title, matching
// where "Add Contacts" sits on the Contacts page — moved here from the table
// toolbar.
const AddAccountButton = () => {
  const [showAddAccountDropDown, setShowAddAccountDropDown] = useState(false);

  const openAddAccountPopup = mode => {
    setShowAddAccountDropDown(false);
    addAccountPopupState.setMode(mode);
    addAccountPopupState.setOnDone(() => accountsState.bumpReloadAccountsList());
    addAccountPopupState.setShowPopup(true);
  };

  const addAccountOptions = [
    {
      icon: {
        ele: '<span class="material-icons-outlined"> person</span>',
        style: { color: "#10cba7" }
      },
      value: "Single",
      key: "singleAccount",
      method: () => openAddAccountPopup("single")
    },
    {
      icon: {
        ele: '<span class="material-icons-outlined"> people</span>',
        style: { color: "#0635c9" }
      },
      value: "Import from CSV",
      key: "csvAccount",
      method: () => openAddAccountPopup("csv")
    }
  ];

  return (
    <div className="addAccountDropDown">
      <Button
        id="addAccountBtn"
        name="addAccountBtn"
        type="button"
        className="addAccountBtn"
        btnText="Add account"
        icon={true}
        loader={false}
        iconName="keyboard_arrow_down"
        click={() => setShowAddAccountDropDown(!showAddAccountDropDown)}
      />
      {showAddAccountDropDown && (
        <>
          <DropdownMenu options={addAccountOptions} referenceId="" />
          <div
            className="dropdown-overlay"
            onClick={e => {
              e.preventDefault();
              setShowAddAccountDropDown(false);
            }}
          />
        </>
      )}
    </div>
  );
};

export default AddAccountButton;
export { AddAccountButton };
